import { HomeTitle } from './HomeTitle';
export default HomeTitle;
